// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  api_formatossui:'https://sevicio-formatos-sui-yzotmrdvwq-uc.a.run.app',
  //api_siigo_dispower: 'https://api-siigo-dispower-629664585428.us-central1.run.app',
  api_siigo_sunpower: 'https://api-siigo-sunpower-629664585428.us-central1.run.app',
  api_procesamiento_archivos: 'https://api-procesamiento-archivos-629664585428.us-central1.run.app',
  api_servicio_aom: 'https://servico-aom-629664585428.us-central1.run.app',
  table: '_Sumpower',
  table_solicitudes: '_Sumpower',
  //api_siigo_sunpower: 'http://localhost:8081',
  //api_formatossui: 'http://localhost:8085',
  //api_procesamiento_archivos: 'http://localhost:8085',
  //api_siigo_dispower: 'http://localhost:8080',
  //api_servicio_aom: 'http://localhost:8088',
  // table: '', Descomentar para obtener datos de producción
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
